@import (reference) '../../../../../constants/spacing.module.less';

.connector {
  align-items: center;
  position: relative;
  height: 82px;
}

.line {
  width: 2px;
  flex: 1;
  background: var(--grey-300);
}

.add-button {
  text-align: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid var(--grey-300);
  background: var(--white);
  color: var(--grey-600);
  cursor: pointer;

  &:hover {
    border-color: var(--blue-500);
    color: var(--blue-500);
  }
}
